import { sendFetch, GET_OPTIONS, POST_OPTIONS, DELETE_OPTIONS } from './base.service';

const BASE_PATH = '/weaving-alert';

export const findAllWeavingAlert = async () => {
    return await sendFetch(`${BASE_PATH}/all`, GET_OPTIONS);
}

export const findAllWeavingAlertWithQuantities = async () => {
    return await sendFetch(`${BASE_PATH}/all/quantities`, GET_OPTIONS);
}

export const createWeavingAlert = async (body) => {
    return await sendFetch(`${BASE_PATH}/create`, POST_OPTIONS, body);
}

export const editWeavingAlert = async (body) => {
    return await sendFetch(`${BASE_PATH}/edit`, POST_OPTIONS, body);
}

export const deleteWeavingAlert = async (id) => {
    return await sendFetch(`${BASE_PATH}/${id}`, DELETE_OPTIONS);
}